import React from "react";
import {
    TextField,
    Button,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Box,
    Typography,
    Select,
    MenuItem,
    Checkbox
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

export const CervicalExaminationTab = ({
    formData,
    setFormData,
    handleChange,
    handleFieldChange,
    handleSubmit,
    screeningStatus,
    handleOpenUpdateModal,
    activeWorkflowTab,
    setActiveWorkflowTab,
    setOpenConfirmDialog,
    activePoints,
    togglePoint,
    isDhOrChc
}) => {
    return (
        <>
            {/* Quick Links & Screening Status Bar */}
            <Box sx={{ p: 2.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, borderBottom: '1px solid #eef2f5', bgcolor: '#fafafa', mb: 3 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography sx={{ fontWeight: 800, color: '#1e293b', fontSize: '15px' }}>
                            Status: {screeningStatus}
                        </Typography>
                        {!isDhOrChc && handleOpenUpdateModal && (
                            <Button
                                variant="text"
                                size="small"
                                sx={{ color: '#3f51b5', fontWeight: 700, minWidth: 'auto', p: 0, textTransform: 'none', textDecoration: 'underline' }}
                                onClick={handleOpenUpdateModal}
                            >
                                Update
                            </Button>
                        )}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Typography sx={{ fontSize: '12px', color: '#3f51b5', fontWeight: 700 }}>
                            📖 Quick Links
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', gap: 2 }}>
                    {/* FOLLOW UP Card */}
                    <Box
                        onClick={() => setActiveWorkflowTab(3)}
                        sx={{
                            width: '95px',
                            height: '75px',
                            border: '1px solid #cbd5e1',
                            borderRadius: '6px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            bgcolor: activeWorkflowTab === 3 ? '#9fa8da' : '#fff',
                            transition: 'all 0.2s',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.03)',
                            '&:hover': { bgcolor: '#9fa8da' }
                        }}
                    >
                        <Typography sx={{ fontSize: '20px', mb: 0.2 }}>📋</Typography>
                        <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#1e293b' }}>
                            FOLLOW UP
                        </Typography>
                    </Box>

                    {/* REFER Card */}
                    <Box
                        onClick={() => setActiveWorkflowTab(4)}
                        sx={{
                            width: '95px',
                            height: '75px',
                            border: '1px solid #cbd5e1',
                            borderRadius: '6px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            bgcolor: activeWorkflowTab === 4 ? '#9fa8da' : '#fff',
                            transition: 'all 0.2s',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.03)',
                            '&:hover': { bgcolor: '#9fa8da' }
                        }}
                    >
                        <Typography sx={{ fontSize: '20px', mb: 0.2 }}>👥</Typography>
                        <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#1e293b' }}>
                            REFER
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <form onSubmit={handleSubmit}>
                <Box className="cirvicalCancerSection" sx={{ mb: 3 }}>

                    {/* Assessment Date Picker & No Abnormality Detected */}
                    <Box className="date_cont" sx={{ mb: 3, display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#334155', fontSize: '16px' }}>
                                Examination
                            </Typography>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formData.noAbnormalityFound || false}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setOpenConfirmDialog(true);
                                            } else {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    noAbnormalityFound: false
                                                }));
                                            }
                                        }}
                                        sx={{ color: '#cbd5e1', '&.Mui-checked': { color: '#3f51b5' } }}
                                    />
                                }
                                label={<Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#475569' }}>No Abnormality Detected</Typography>}
                            />
                        </Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Assessment Date"
                                format="DD/MM/YYYY"
                                value={formData.assessmentDate ? dayjs(formData.assessmentDate, 'YYYY-MM-DD') : null}
                                onChange={(newValue) => (handleFieldChange ? handleFieldChange('assessmentDate', newValue ? newValue.format('YYYY-MM-DD') : '') : setFormData(prev => ({ ...prev, assessmentDate: newValue ? newValue.format('YYYY-MM-DD') : '' })))}
                                maxDate={dayjs()}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        size: 'small',
                                        sx: { maxWidth: 300 }
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </Box>

                    {/* VIA Testing Panels */}
                    <div className="VIATesting" style={{ marginBottom: '30px', pointerEvents: formData.noAbnormalityFound ? 'none' : 'auto', opacity: formData.noAbnormalityFound ? 0.6 : 1 }}>
                        <div className="panel panel-success" style={{ border: '1px solid #d6e9c6', borderRadius: '4px', marginBottom: '15px' }}>
                            <div className="panel-heading" style={{ background: '#dff0d8', color: '#3c763d', padding: '10px 15px' }}>
                                <FormControlLabel
                                    value="Negative"
                                    control={
                                        <Radio
                                            name="cirvical"
                                            onChange={handleChange}
                                            checked={formData.viaTestResult === "Negative"}
                                            disabled={formData.noAbnormalityFound}
                                            sx={{
                                                color: '#3c763d',
                                                '&.Mui-checked': {
                                                    color: '#3c763d',
                                                },
                                                p: 0,
                                                mr: 1
                                            }}
                                        />
                                    }
                                    label="Negative"
                                    sx={{
                                        m: 0,
                                        width: '100%',
                                        '& .MuiFormControlLabel-label': {
                                            fontWeight: 600,
                                            color: '#3c763d'
                                        }
                                    }}
                                />
                            </div>
                            <div className="panel-body" style={{ padding: '15px' }}>
                                <p>No aceto-white lesions without definite margins</p>
                                <p>Transparent lesions or faint patchy lesions</p>
                                <p>Nabothian cysts becoming aceto-white</p>
                                <p>Faint line like aceto-whitening at the junction of columnar and squamous epithelium</p>
                                <p>Faint aceto-white lesions far away from the transformation zone</p>
                            </div>
                        </div>

                        <div className="panel panel-danger" style={{ border: '1px solid #ebccd1', borderRadius: '4px', marginBottom: '15px' }}>
                            <div className="panel-heading" style={{ background: '#f2dede', color: '#a94442', padding: '10px 15px' }}>
                                <FormControlLabel
                                    value="Positive"
                                    control={
                                        <Radio
                                            name="cirvical"
                                            checked={formData.viaTestResult === "Positive"}
                                            onChange={handleChange}
                                            disabled={formData.noAbnormalityFound}
                                            sx={{
                                                color: '#a94442',
                                                '&.Mui-checked': {
                                                    color: '#a94442',
                                                },
                                                p: 0,
                                                mr: 1
                                            }}
                                        />
                                    }
                                    label="Positive"
                                    sx={{
                                        m: 0,
                                        width: '100%',
                                        '& .MuiFormControlLabel-label': {
                                            fontWeight: 600,
                                            color: '#a94442'
                                        }
                                    }}
                                />
                            </div>
                            <div className="panel-body" style={{ padding: '15px' }}>
                                <p>Distinct, opaque aceto-white area</p>
                                <p>Margin should be well defined, may or may not be raised</p>
                                <p>Abnormality close to the squamo-columnar junction in the transformation zone and not far away from the os</p>
                                <p>Entire cervix becomes densely white after the application of acetic acid</p>
                                <p>Strikingly dense acetowhite areas are seen in the columnar epithelium</p>
                            </div>
                        </div>

                        <div className="panel panel-warning" style={{ border: '1px solid #faebcc', borderRadius: '4px', marginBottom: '15px' }}>
                            <div className="panel-heading" style={{ background: '#fcf8e3', color: '#8a6d3b', padding: '10px 15px' }}>
                                <FormControlLabel
                                    value="Suspicious"
                                    control={
                                        <Radio
                                            name="cirvical"
                                            onChange={handleChange}
                                            checked={formData.viaTestResult === "Suspicious"}
                                            disabled={formData.noAbnormalityFound}
                                            sx={{
                                                color: '#8a6d3b',
                                                '&.Mui-checked': {
                                                    color: '#8a6d3b',
                                                },
                                                p: 0,
                                                mr: 1
                                            }}
                                        />
                                    }
                                    label="Suspicious of cancer"
                                    sx={{
                                        m: 0,
                                        width: '100%',
                                        '& .MuiFormControlLabel-label': {
                                            fontWeight: 600,
                                            color: '#8a6d3b'
                                        }
                                    }}
                                />
                            </div>

                            <div className="panel-body" style={{ padding: '15px' }}>
                                <p>Obvious growth or ulcer in the cervix. Aceto-white area may not be visible because of bleeding</p>
                            </div>
                        </div>
                    </div>

                    {/* Clock Visualizer Diagram */}
                    <div className="cirvicalImgSection" style={{ display: 'flex', justifyContent: 'center', marginBottom: '30px', pointerEvents: (formData.noAbnormalityFound || (formData.viaTestResult !== "Positive" && formData.viaTestResult !== "Suspicious")) ? 'none' : 'auto', opacity: (formData.noAbnormalityFound || (formData.viaTestResult !== "Positive" && formData.viaTestResult !== "Suspicious")) ? 0.6 : 1 }}>
                        <div className="circle-container" style={{ position: 'relative', width: '325px', height: '329px' }}>
                            <img src={"/images/cervical_cancer_diagram.png"} style={{ width: '325px', height: '329px' }} alt="Cervical Cancer Diagram" />
                            {Array.from({ length: 12 }).map((_, i) => {
                                const rotatedIndex = (i + 1) % 12;
                                const angle = (360 / 12) * rotatedIndex - 90;
                                const radius = 120;
                                const x = radius * Math.cos((angle * Math.PI) / 180);
                                const y = radius * Math.sin((angle * Math.PI) / 180);

                                return (
                                    <div
                                        key={i}
                                        className={`dotCirvical ${activePoints && activePoints[i] ? "active" : ""}`}
                                        style={{
                                            transform: `translate(${x}px, ${y}px)`,
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            width: '34px',
                                            height: '34px',
                                            marginTop: '-17px',
                                            marginLeft: '-17px',
                                        }}
                                        onClick={() => togglePoint && togglePoint(i)}
                                    />
                                );
                            })}
                        </div>
                    </div>

                    {/* Examination Form Sections */}
                    <div className="cirvicalFormSection" style={{ marginTop: '30px', pointerEvents: formData.noAbnormalityFound ? 'none' : 'auto', opacity: formData.noAbnormalityFound ? 0.6 : 1 }}>

                        <Box className="row" sx={{ mb: 2 }}>
                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>External Genitalia Healthy:</FormLabel>
                                    <RadioGroup
                                        name="isExternalGenitaliaHealthy"
                                        value={formData.isExternalGenitaliaHealthy === null ? "" : String(formData.isExternalGenitaliaHealthy)}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('isExternalGenitaliaHealthy', e.target.value === "true") : setFormData(prev => ({ ...prev, isExternalGenitaliaHealthy: e.target.value === "true" })))}
                                        row
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                                {formData.isExternalGenitaliaHealthy === false && (
                                    <TextField
                                        fullWidth
                                        name="otherFindingsByAnnualRemarks"
                                        label="Remarks"
                                        value={formData.otherFindingsByAnnualRemarks || ''}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('otherFindingsByAnnualRemarks', e.target.value) : setFormData(prev => ({ ...prev, otherFindingsByAnnualRemarks: e.target.value })))}
                                        sx={{ mt: 1 }}
                                    />
                                )}
                            </Box>
                        </Box>

                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 3, borderBottom: '1px solid #e0e0e0', pb: 1 }}>
                            Per speculum examination:
                        </Typography>

                        <Box className="row" sx={{ mb: 2 }}>
                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Polyp:</FormLabel>
                                    <RadioGroup
                                        name="polyp"
                                        value={formData.polyp === null ? "" : String(formData.polyp)}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('polyp', e.target.value === "true") : setFormData(prev => ({ ...prev, polyp: e.target.value === "true" })))}
                                        row
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>

                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Ectopy (Erosion):</FormLabel>
                                    <RadioGroup
                                        name="ectopy"
                                        value={formData.ectopy === null ? "" : String(formData.ectopy)}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('ectopy', e.target.value === "true") : setFormData(prev => ({ ...prev, ectopy: e.target.value === "true" })))}
                                        row
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>

                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Hypertrophy:</FormLabel>
                                    <RadioGroup
                                        name="hypertrophy"
                                        value={formData.hypertrophy === null ? "" : String(formData.hypertrophy)}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('hypertrophy', e.target.value === "true") : setFormData(prev => ({ ...prev, hypertrophy: e.target.value === "true" })))}
                                        row
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        </Box>

                        <Box className="row" sx={{ mb: 2 }}>
                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Excessive Discharge:</FormLabel>
                                    <RadioGroup
                                        name="excessiveDischarge"
                                        value={formData.excessiveDischarge === null ? "" : String(formData.excessiveDischarge)}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('excessiveDischarge', e.target.value === "true") : setFormData(prev => ({ ...prev, excessiveDischarge: e.target.value === "true" })))}
                                        row
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>

                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Prolapse Uterus:</FormLabel>
                                    <RadioGroup
                                        name="prolapseUterus"
                                        value={formData.prolapseUterus === null ? "" : String(formData.prolapseUterus)}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('prolapseUterus', e.target.value === "true") : setFormData(prev => ({ ...prev, prolapseUterus: e.target.value === "true" })))}
                                        row
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>

                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Bleeds on Touch:</FormLabel>
                                    <RadioGroup
                                        name="bleedsOnTouch"
                                        value={formData.bleedsOnTouch === null ? "" : String(formData.bleedsOnTouch)}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('bleedsOnTouch', e.target.value === "true") : setFormData(prev => ({ ...prev, bleedsOnTouch: e.target.value === "true" })))}
                                        row
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        </Box>

                        <Box className="row" sx={{ mb: 2 }}>
                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Unhealthy Cervix:</FormLabel>
                                    <RadioGroup
                                        name="unhealthyCervix"
                                        value={formData.unhealthyCervix === null ? "" : String(formData.unhealthyCervix)}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('unhealthyCervix', e.target.value === "true") : setFormData(prev => ({ ...prev, unhealthyCervix: e.target.value === "true" })))}
                                        row
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>

                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Suspicious looking Cervix:</FormLabel>
                                    <RadioGroup
                                        name="suspiciousCervix"
                                        value={formData.suspiciousCervix === null ? "" : String(formData.suspiciousCervix)}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('suspiciousCervix', e.target.value === "true") : setFormData(prev => ({ ...prev, suspiciousCervix: e.target.value === "true" })))}
                                        row
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>

                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Frank Malignancy or Growth on the Cervix:</FormLabel>
                                    <RadioGroup
                                        name="frankMalignancy"
                                        value={formData.frankMalignancy === null ? "" : String(formData.frankMalignancy)}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('frankMalignancy', e.target.value === "true") : setFormData(prev => ({ ...prev, frankMalignancy: e.target.value === "true" })))}
                                        row
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        </Box>

                        <Box className="row" sx={{ mb: 2 }}>
                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Others:</FormLabel>
                                    <RadioGroup
                                        name="other"
                                        value={formData.other === null ? "" : String(formData.other)}
                                        onChange={(e) => {
                                            const isOther = e.target.value === "true";
                                            setFormData(prev => ({
                                                ...prev,
                                                other: isOther,
                                                otherStr: isOther ? prev.otherStr : ''
                                            }));
                                        }}
                                        row
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                            {formData.other && (
                                <Box className="col-md-8 col-xs-12" sx={{ mb: 2 }}>
                                    <TextField
                                        fullWidth
                                        name="otherStr"
                                        label="Please specify other findings"
                                        value={formData.otherStr || ''}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('otherStr', e.target.value) : setFormData(prev => ({ ...prev, otherStr: e.target.value })))}
                                    />
                                </Box>
                            )}
                        </Box>

                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 3, borderBottom: '1px solid #e0e0e0', pb: 1, mt: 3 }}>
                            Bimanual examination:
                        </Typography>

                        <Box className="row" sx={{ mb: 2 }}>
                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth size="small" disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Bimanual Examination:</FormLabel>
                                    <Select
                                        name="byAnnualExamination"
                                        value={formData.byAnnualExamination || ''}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('byAnnualExamination', e.target.value) : setFormData(prev => ({ ...prev, byAnnualExamination: e.target.value })))}
                                        displayEmpty
                                    >
                                        <MenuItem value="">Select</MenuItem>
                                        <MenuItem value="Normal">Normal</MenuItem>
                                        <MenuItem value="Abnormal">Abnormal</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>

                            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                <FormControl fullWidth disabled={formData.noAbnormalityFound}>
                                    <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Other Findings:</FormLabel>
                                    <RadioGroup
                                        name="otherFindingsByannual"
                                        value={formData.otherFindingsByannual === null ? "" : String(formData.otherFindingsByannual)}
                                        onChange={(e) => {
                                            const hasOther = e.target.value === "true";
                                            setFormData(prev => ({
                                                ...prev,
                                                otherFindingsByannual: hasOther,
                                                otherFindingsByAnnualRemarks: hasOther ? prev.otherFindingsByAnnualRemarks : ''
                                            }));
                                        }}
                                        row
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                            {formData.otherFindingsByannual && (
                                <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
                                    <TextField
                                        fullWidth
                                        name="otherFindingsByAnnualRemarks"
                                        label="Please specify other remarks"
                                        value={formData.otherFindingsByAnnualRemarks || ''}
                                        onChange={(e) => (handleFieldChange ? handleFieldChange('otherFindingsByAnnualRemarks', e.target.value) : setFormData(prev => ({ ...prev, otherFindingsByAnnualRemarks: e.target.value })))}
                                    />
                                </Box>
                            )}
                        </Box>

                    </div>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{
                                bgcolor: '#3f51b5',
                                color: '#fff',
                                fontWeight: 700,
                                textTransform: 'none',
                                px: 4.5,
                                py: 1,
                                borderRadius: '4px',
                                '&:hover': { bgcolor: '#303f9f' }
                            }}
                        >
                            Save & Continue
                        </Button>
                    </Box>

                </Box>
            </form>
        </>
    );
};
